import React from 'react';
import { loadCalendars, toggleCalendar } from 'actions/Calendars';
import { connect } from 'react-redux';
import {DialogContent, List, ListItem, ListItemSecondaryAction, ListItemText} from "material-ui";
import Avatar from "material-ui/Avatar/Avatar";
import {Add, Edit, Visibility, VisibilityOff} from "material-ui-icons";
import IconButton from "material-ui/IconButton/IconButton";
import tsl from "app/tsl";
import withStyles from "material-ui/styles/withStyles";
import Divider from "material-ui/Divider/Divider";

const styles = theme => ({
  listItemText: {
    color: 'inherit'
  },
  smallAvatar: {
    width: 24,
    height: 24
  },
  smallIcon: {
    width: 20,
    height: 20
  }
});

class CalendarList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    /* enable this when calendar screen will be refactored to fully work with redux */

    // if (null === this.props.calendars) {
    //   this.props.loadCalendars();
    // }
  }

  handleChangeCalendarDisplay = (calendarId) => () => {
    this.props.toggleCalendar(calendarId);
  };

  render() {
    const { calendars, displayedCalendars, classes } = this.props;

    if (null === calendars) {
      return null;
    }

    return (
      <List>
        <ListItem>
          <ListItemText
            classes={{ text: classes.listItemText }}
            primary={tsl('menu.calendar')}
          />
        </ListItem>

        {Object.values(calendars).map((calendar, index) => {
            return (
                <ListItem
                  dense
                  button
                  key={index}
                  onClick={this.handleChangeCalendarDisplay(calendar.id)}
                >
                    <Avatar
                      style={{color: 'white', backgroundColor: calendar.color_hex}}
                      className={classes.smallAvatar}
                    >
                        {displayedCalendars.indexOf(calendar.id) === -1
                            ? <VisibilityOff className={classes.smallIcon} />
                            : <Visibility className={classes.smallIcon} />
                        }
                    </Avatar>
                    <ListItemText
                      classes={{ text: classes.listItemText }}
                      primary={calendar.name}
                    />
                    {/*calendar.aircraft ? '' :
                        <ListItemSecondaryAction>
                            <IconButton color="inherit" onClick={this.handleEditCalendar(calendar)}>
                                <Edit />
                            </IconButton>
                        </ListItemSecondaryAction>
                    */}
                </ListItem>
            );
        })}
      </List>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    calendars: state.calendars.list,
    displayedCalendars: state.calendars.displayed
  }
};

const mapDispatchToProps = {
  loadCalendars,
  toggleCalendar
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles)(CalendarList)
);


// WEBPACK FOOTER //
// ./components/CalendarList/index.js